import { useQuery } from '@apollo/client';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  AppContext,
  DropdownIndicator,
  formatDataForSelectDropdown,
  formatGroupLabel,
  getTranslatedText,
  IndicatorSeparator,
  isAuthorised
} from '@nile/components';
import { AccountClient, GET_ALL_TAX } from '@nile/graphql';
import { Checkbox, ToggleButton, Dropdown } from '@superops/ui-design-system';
import { includes, omit } from 'lodash';
import React, { useContext } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

function TaxConfiguration(props) {
  const flags = useFlags();
  const {
    intl,
    salesTaxEnabled,
    salesTax,
    disabledSections,
    handlePropChange,
    properties = { salesTaxEnabled: 'salesTaxEnabled', salesTax: 'salesTax' },
    label = {
      salesTaxEnabled: 'admin.serviceCatalog.taxConfiguration.salesTaxEnabled',
      salesTax: 'admin.serviceCatalog.taxConfiguration.salesTax'
    },
    negate
  } = props;
  const { user } = useContext(AppContext);
  const reference = user?.role?.roleFeatureList || [];
  const clientLocation = user?.site?.countryCode || false;
  const isTaxForIndividualItemsNotAllowed = false;

  const { loading: taxLoading, error: taxError, data: taxData } = useQuery(
    GET_ALL_TAX,
    {
      client: AccountClient,
      skip: !isAuthorised(reference, 'tax.view')
    }
  );
  const taxRateList = taxData?.getAllTax
    ? formatDataForSelectDropdown(taxData?.getAllTax)
    : [];
  const showTaxRegion = negate ? !salesTaxEnabled : salesTaxEnabled;
  return (
    <div className="fx actr min-height-42">
      <div className="fx actr">
        <ToggleButton
          value={salesTaxEnabled}
          onChange={(checked) => {
            handlePropChange(
              properties.salesTaxEnabled,
              negate ? !checked : checked
            );
          }}
          locked={includes(disabledSections, 'salesTaxEnabled')}
          size="small"
        />
        <span className="ml8">
          <FormattedMessage id={label.salesTaxEnabled} />
        </span>
      </div>
      {!isTaxForIndividualItemsNotAllowed && showTaxRegion && (
        <div className="flex center ml-40">
          <div className="mr-10">
            <FormattedMessage id={label.salesTax} />
          </div>
          <div className="w200">
            <Dropdown
              classNamePrefix="value_selector"
              formatGroupLabel={formatGroupLabel}
              components={{ IndicatorSeparator, DropdownIndicator }}
              title={getTranslatedText(intl, 'admin.serviceCatalog.taxRegion')}
              onChange={(selectedTaxRate, el1) => {
                const salesTaxValue = {
                  ...omit(selectedTaxRate, [
                    'label',
                    'value',
                    'id',
                    'rates',
                    'integrated'
                  ])
                };
                handlePropChange(properties.salesTax, salesTaxValue);
              }}
              options={taxRateList}
              placeholder={getTranslatedText(
                intl,
                'admin.serviceCatalog.selectTaxRegion'
              )}
              menuPortalTarget={document.body}
              menuPlacement="auto"
              closeMenuOnScroll={(e) => {
                return (
                  e.target &&
                  e.target.classList &&
                  !(e.target.classList.value.indexOf('menu-list') > -1)
                );
              }}
              value={
                salesTax
                  ? { ...salesTax, label: salesTax.name, value: salesTax.name }
                  : null
              }
              name="valueselector"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 })
              }}
              noOptionsMessage={() => {
                return taxLoading ? 'Loading...' : 'No options';
              }}
              isClearable={false}
              isDisabled={includes(disabledSections, 'salesTax')}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default injectIntl(TaxConfiguration);
